import { Link } from 'react-router-dom';
import BuiltByCredit from '../../components/BuiltByCredit';
import { ThemeToggle } from '../../components/theme/ThemeToggle';
import { useAuthStore } from '../../stores/auth.store';

export default function LearnFooter() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  return (
    <footer className="bg-base-200 border-t border-base-300">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2">
              <img src="/logo.webp" alt="EmpathEase" className="h-10 w-10 rounded-xl" />
              <span className="font-bold text-xl">EmpathEase</span>
            </Link>
            <p className="mt-3 text-base-content/60 text-sm">
              Learn the communication skills that transform relationships.
            </p>
          </div>
          <div>
            <h3 className="font-semibold text-base-content mb-3">Learn</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/learn"
                  className="text-base-content/60 hover:text-base-content transition-colors text-sm"
                >
                  All Articles
                </Link>
              </li>
              <li>
                <Link
                  to="/conflict-resolution"
                  className="text-base-content/60 hover:text-base-content transition-colors text-sm"
                >
                  Conflict Resolution
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="font-semibold text-base-content mb-3">Get Started</h3>
            <ul className="space-y-2">
              {isAuthenticated ? (
                <>
                  <li>
                    <Link
                      to="/app"
                      className="text-base-content/60 hover:text-base-content transition-colors text-sm"
                    >
                      Dashboard
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/quiz-assessment"
                      className="text-base-content/60 hover:text-base-content transition-colors text-sm"
                    >
                      Take the Quiz
                    </Link>
                  </li>
                </>
              ) : (
                <>
                  <li>
                    <Link
                      to="/quiz-assessment"
                      className="text-base-content/60 hover:text-base-content transition-colors text-sm"
                    >
                      Take the Quiz
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/register"
                      className="text-base-content/60 hover:text-base-content transition-colors text-sm"
                    >
                      Start Free
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/login"
                      className="text-base-content/60 hover:text-base-content transition-colors text-sm"
                    >
                      Log in
                    </Link>
                  </li>
                </>
              )}
            </ul>
          </div>
          <div>
            <h3 className="font-semibold text-base-content mb-3">Legal</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/privacy"
                  className="text-base-content/60 hover:text-base-content transition-colors text-sm"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/terms"
                  className="text-base-content/60 hover:text-base-content transition-colors text-sm"
                >
                  Terms of Service
                </Link>
              </li>
              <li>
                <a
                  href="mailto:hello@empathease.app"
                  className="text-base-content/60 hover:text-base-content transition-colors text-sm"
                >
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-8 pt-8 border-t border-base-300">
          <p className="text-center text-sm text-(--ee-public-ink-50)">
            &copy; {new Date().getFullYear()} EmpathEase. Made with love for connection.
            <BuiltByCredit />
          </p>
          <ThemeToggle
            className="mt-4 mx-auto flex items-center justify-center"
            testId="theme-toggle-footer"
          />
        </div>
      </div>
    </footer>
  );
}
